import { motion } from "framer-motion";
import { ABOUT } from "@/constants/testIds";
import TiltCard from "@/components/TiltCard";
import { ShieldCheck, MapPin } from "lucide-react";

export default function TrustBadges({ site }) {
    const badges = [
        { label: "GST", value: site?.gst || "07FBKPA2936P1Z8", tid: ABOUT.badgeGst },
        { label: "MSME · Udyam", value: site?.msme || "UDYAM-UK-02-0004950", tid: ABOUT.badgeMsme },
        { label: "IEC", value: site?.iec || "FBKPA2936P", tid: ABOUT.badgeIec },
    ];

    return (
        <section
            id="trust-badges"
            data-testid="trust-badges-section"
            className="relative py-20 md:py-24"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        Verified · Registered
                    </p>
                    <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[var(--text-primary)]">
                        A real business. On paper.{" "}
                        <span className="italic text-[var(--accent-champagne)]">
                            On record.
                        </span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 perspective-1000">
                    {badges.map((b, i) => (
                        <motion.div
                            key={b.label}
                            initial={{ opacity: 0, y: 24, rotateY: -8 }}
                            whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: 0.12 * i }}
                        >
                            <TiltCard intensity={7} lift={6}>
                                <div
                                    data-testid={b.tid}
                                    className="surface-3d rounded-2xl p-6 md:p-7 relative overflow-hidden"
                                >
                                    <div className="flex items-start justify-between gap-4">
                                        <div>
                                            <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--accent-champagne)]/70 mb-2">
                                                Verified · Registered
                                            </p>
                                            <p className="font-display text-2xl md:text-3xl font-bold text-[var(--text-primary)]">
                                                {b.label}
                                            </p>
                                            <p className="mt-2 font-body text-[var(--text-secondary)] text-sm md:text-base tracking-widest">
                                                {b.value}
                                            </p>
                                        </div>
                                        <div className="shrink-0 w-12 h-12 rounded-full bg-[rgba(212,175,55,0.15)] border border-[var(--border-accent)] flex items-center justify-center">
                                            <ShieldCheck
                                                size={20}
                                                className="text-[var(--accent-gold)]"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </TiltCard>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-10 flex justify-center">
                    <div
                        data-testid="trust-office"
                        className="inline-flex items-center gap-3 text-sm text-[var(--text-secondary)] px-4 py-2 rounded-full border border-[var(--border-subtle)] bg-[rgba(255,255,255,0.02)]"
                    >
                        <MapPin size={14} className="text-[var(--accent-gold)]" />
                        Registered office · {site?.address || "Dehradun, Uttarakhand, India"}
                    </div>
                </div>
            </div>
        </section>
    );
}
